import React from 'react'

export default function printYear(year, season) {
    let result = year.toString();
    if (season === 2) {
        result = `${year}/${year + 1}`
    }
    return (
        <div>
            {season} {result}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/core/CollectionHelper.js